<template>
  <screen-locker>
    <template v-slot:content>
      <div class="page page-scenario d-flex flex-column">
        <AppHeader :step-active="5"></AppHeader>
        <div class="row header-page">
          <div class="col h-100">
            <h3>
              Scopri i possibili andamenti del tuo investimento
            </h3>
            <div class="row banner-area h-100">
              <div class="col h-100">
                <div class="banner banner-scenario banner-description h-100">
                  <div class="row">
                    <div class="col-12 position-absolute">
                      <div
                        class="svg-banner-area w-100 h-100 d-flex align-items-center"
                      >
                        <svg-viewer
                          :src="
                            window.width <= 1440
                              ? require('../assets/images/banner/06-main.svg')
                              : require('../assets/images/banner/06-wide.svg')
                          "
                          width="100%"
                          :height="
                            window.width <= 1440
                              ? window.height > 768
                                ? '350px'
                                : '100%'
                              : '430px'
                          "
                        ></svg-viewer>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-5">
                      Le performance illustrate nelle simulazioni si intendono
                      al netto dei costi e al lordo della tassazione<br />
                      I valori sviluppati sono meramente indicativi e non
                      impegnano in alcun modo Generali Italia.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row form-data mt-3">
          <div class="col mt-3">
            <b-tabs pills class="list-tabs" v-if="false">
              <b-tab title="Vista grafico">
                <b-card-text>
                  <div class="table-data">
                    <highcharts :options="chartOptions"></highcharts>
                  </div>
                  <div
                    class="d-flex flex-row justify-content-center"
                    style="margin: 0 1% 0 7%"
                  >
                    <div class="flex-fill text-center">
                      <b-button @click="showModal('stressato')"
                        >+ Stress</b-button
                      >
                    </div>
                    <div class="flex-fill text-center">
                      <b-button @click="showModal('sfavorevole')"
                        >+ Sfavorevole</b-button
                      >
                    </div>
                    <div class="flex-fill text-center">
                      <b-button @click="showModal('moderato')"
                        >+ Moderato</b-button
                      >
                    </div>
                    <div class="flex-fill text-center">
                      <b-button @click="showModal('favorevole')"
                        >+ Favorevole</b-button
                      >
                    </div>
                  </div>
                </b-card-text>
              </b-tab>
              <b-tab title="Vista tabella" v-if="false">
                <b-card-text>
                  <div class="table-data">
                    <b-table
                      small
                      :items="scenarios.data"
                      :fields="scenarios.fields"
                    >
                      <template v-slot:cell(name)="data">
                        {{ data.value }}
                      </template>
                      <template v-slot:cell()="data">
                        {{ data.value | currency }}
                      </template>
                    </b-table>
                  </div>
                </b-card-text>
              </b-tab>
            </b-tabs>
            <div class="table-data">
              <highcharts :options="chartOptions"></highcharts>
            </div>
            <div
              class="d-flex flex-row justify-content-center"
              style="margin: 0 1% 0 7%"
            >
              <div class="flex-fill text-center">
                <b-button @click="showModal('stressato')">+ Stress</b-button>
              </div>
              <div class="flex-fill text-center">
                <b-button @click="showModal('sfavorevole')"
                  >+ Sfavorevole</b-button
                >
              </div>
              <div class="flex-fill text-center">
                <b-button @click="showModal('moderato')">+ Moderato</b-button>
              </div>
              <div class="flex-fill text-center">
                <b-button @click="showModal('favorevole')"
                  >+ Favorevole</b-button
                >
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex footer-page">
          <b-button variant="link" @click="back()">
            <img alt="Indietro" src="../assets/images/back.svg" />
            Indietro
          </b-button>
          <b-button variant="primary ml-auto" @click="processData()"
            >Avanti</b-button
          >
        </div>
        <b-modal
          v-model="modal"
          adaptive="true"
          title="Dettaglio Scenario"
          dialog-class="modal-full"
          hide-footer
        >
          <template v-slot:modal-header>
            &nbsp;
            <b-button
              variant="link modal-close"
              size="sm"
              class="float-right"
              @click="modal = false"
            >
              <img src="../assets/images/close.svg" alt="Chiudi" />
            </b-button>
          </template>
          <b-container style="height: 80vh">
            <ScenarioDett
              v-if="modal"
              :type="scenarioDetailType"
            ></ScenarioDett>
          </b-container>
        </b-modal>
        <auth-guard />
      </div>
    </template>
  </screen-locker>
</template>

<script>
import router from "../router";
import ScenarioDett from "./modals/ScenarioDett";
import { ColumnLineChartDataScenarios } from "../data/column-line-chart-data.scenarios";
import { ScenariosData } from "../data/scenarios.data";
import { ExtraProtectionData } from "../data/extra-protection.data";
import ScenarioTypeEnum from "../enums/scenario-type.enum";
import { formatDecimal, formatInt } from "../utils/generic.utils";
export default {
  name: "Scenario",
  components: { ScenarioDett },
  data: () => {
    return {
      val: false,
      modal: false,
      scenarioDetailType: "stressed",
      scenarios: {},
      extraProtectionList: [],
      chartOptions: {},
      window: {
        width: 0,
        height: 0
      }
    };
  },
  created() {
    this.initScearios();
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  methods: {
    initScearios() {
      this.scenarios = JSON.parse(JSON.stringify(ScenariosData));
      this.extraProtectionList = JSON.parse(
        JSON.stringify(ExtraProtectionData)
      );

      const scenarioStressed =
        this.$store.state.scenarios.filter(
          s => s.type === ScenarioTypeEnum.STRESSED
        ).length > 0
          ? this.$store.state.scenarios.filter(
              s => s.type === ScenarioTypeEnum.STRESSED
            )[0]
          : null;
      const scenarioFavorable =
        this.$store.state.scenarios.filter(
          s => s.type === ScenarioTypeEnum.FAVORABLE
        ).length > 0
          ? this.$store.state.scenarios.filter(
              s => s.type === ScenarioTypeEnum.FAVORABLE
            )[0]
          : null;
      const scenarioModerate =
        this.$store.state.scenarios.filter(
          s => s.type === ScenarioTypeEnum.MODERATE
        ).length > 0
          ? this.$store.state.scenarios.filter(
              s => s.type === ScenarioTypeEnum.MODERATE
            )[0]
          : null;
      const scenarioUnfavorable =
        this.$store.state.scenarios.filter(
          s => s.type === ScenarioTypeEnum.UNFAVORABLE
        ).length > 0
          ? this.$store.state.scenarios.filter(
              s => s.type === ScenarioTypeEnum.UNFAVORABLE
            )[0]
          : null;

      this.scenarios.data[0].stressed = Number(
        scenarioStressed.finalPerformanceArr[
          Number(this.$store.state.yearValue) - 1
        ]
      ).toFixed(2);
      this.scenarios.data[1].stressed = Number(
        scenarioStressed.deathTotalArr[Number(this.$store.state.yearValue) - 1]
      ).toFixed(2);
      this.scenarios.data[2].stressed = Number(
        scenarioStressed.surrenderValueArr[
          Number(this.$store.state.yearValue) - 1
        ]
      ).toFixed(2);

      this.scenarios.data[0].favorable = Number(
        scenarioFavorable.finalPerformanceArr[
          Number(this.$store.state.yearValue) - 1
        ]
      ).toFixed(2);
      this.scenarios.data[1].favorable = Number(
        scenarioFavorable.deathTotalArr[Number(this.$store.state.yearValue) - 1]
      ).toFixed(2);
      this.scenarios.data[2].favorable = Number(
        scenarioFavorable.surrenderValueArr[
          Number(this.$store.state.yearValue) - 1
        ]
      ).toFixed(2);

      this.scenarios.data[0].moderate = Number(
        scenarioModerate.finalPerformanceArr[
          Number(this.$store.state.yearValue) - 1
        ]
      ).toFixed(2);
      this.scenarios.data[1].moderate = Number(
        scenarioModerate.deathTotalArr[Number(this.$store.state.yearValue) - 1]
      ).toFixed(2);
      this.scenarios.data[2].moderate = Number(
        scenarioModerate.surrenderValueArr[
          Number(this.$store.state.yearValue) - 1
        ]
      ).toFixed(2);

      this.scenarios.data[0].unfavorable = Number(
        scenarioUnfavorable.finalPerformanceArr[
          Number(this.$store.state.yearValue) - 1
        ]
      ).toFixed(2);
      this.scenarios.data[1].unfavorable = Number(
        scenarioUnfavorable.deathTotalArr[
          Number(this.$store.state.yearValue) - 1
        ]
      ).toFixed(2);
      this.scenarios.data[2].unfavorable = Number(
        scenarioUnfavorable.surrenderValueArr[
          Number(this.$store.state.yearValue)
        ] - 1
      ).toFixed(2);

      // add data in chart
      this.chartOptions = JSON.parse(
        JSON.stringify(ColumnLineChartDataScenarios)
      );

      const extraProtectionTooltip =
        "<tr >" +
        '<td style="padding:2px">Capitale in caso di: </td>' +
        '<td style="padding:2px"></td>' +
        "</tr>" +
        "<tr>" +
        '<td style="padding:2px 2px 2px 20px">decesso</td>' +
        '<td style="padding:2px"><b>&euro; {point.deathValue}</b></td>' +
        "</tr>" +
        "<tr>" +
        '<td style="padding:2px 2px 2px 20px">decesso da infortunio</td>' +
        '<td style="padding:2px"><b>&euro; {point.deathIncidentCapital}</b></td>' +
        "</tr>" +
        "<tr>" +
        '<td style="padding:2px 2px 2px 20px">decesso da incidente stradale</td>' +
        '<td style="padding:2px"><b>&euro; {point.deathTrafficAccidentCapital}</b></td>' +
        "</tr>";

      const noExtraProtectionTooltip =
        "<tr>" +
        '<td style="padding:2px">Capitale in caso di decesso: </td>' +
        '<td style="padding:2px"><b>&euro; {point.deathValue}</b></td>' +
        "</tr>";

      // ----
      this.chartOptions.tooltip = {
        headerFormat:
          '<span style="font-size:10px">Scenario {point.key}</span><table>',
        pointFormat:
          '<tr><td style="padding:2px">{series.name}: </td>' +
          '<td style="padding:2px"><b>&euro; {point.surrenderCapital}</b></td></tr>' +
          "<tr >" +
          '<td style="padding:2px">Premio versato: </td>' +
          '<td style="padding:2px"><b>&euro; {point.capitalValue}</b></td>' +
          "</tr>" +
          "<tr >" +
          '<td style="padding:2px">Rendimento del contratto: </td>' +
          '<td style="padding:2px"><b>{point.tirCostLastYearValue} %</b></td>' +
          "</tr>" +
          "</tr>" +
          "<tr >" +
          '<td style="padding:2px">Valore del contratto: </td>' +
          '<td style="padding:2px"><b>&euro; {point.finalPerformanceValue}</b></td>' +
          "</tr>" +
          (this.$store.state.extraProtectionValue.length > 0
            ? extraProtectionTooltip
            : noExtraProtectionTooltip),
        footerFormat: "</table>",
        shared: true,
        useHTML: true
      };
      // this.chartOptions.scenarioData = this.scenarios.data;

      this.chartOptions.series[0].data = [
        {
          y: Number(
            scenarioStressed.surrenderValueArr[
              Number(this.$store.state.yearValue) - 1
            ].toFixed(2)
          ),
          surrenderCapital: formatInt(
            Number(
              scenarioStressed.surrenderValueArr[
                Number(this.$store.state.yearValue) - 1
              ].toFixed(2)
            )
          ),
          deathIncidentCapital: formatInt(
            Number(
              scenarioStressed.deathTotalArr[
                Number(this.$store.state.yearValue) - 1
              ].toFixed(2)
            ) +
              Number(
                scenarioStressed.ACMAExtraProtectionValuieArr[
                  Number(this.$store.state.yearValue) - 1
                ].toFixed(2)
              )
          ),
          deathTrafficAccidentCapital: formatInt(
            Number(
              scenarioStressed.deathTotalArr[
                Number(this.$store.state.yearValue) - 1
              ].toFixed(2)
            ) +
              2 *
                Number(
                  scenarioStressed.ACMAExtraProtectionValuieArr[
                    Number(this.$store.state.yearValue) - 1
                  ].toFixed(2)
                )
          ),
          deathValue: formatInt(
            Number(
              scenarioStressed.deathTotalArr[
                Number(this.$store.state.yearValue) - 1
              ].toFixed(2)
            )
          ),
          tirCostLastYearValue: formatDecimal(
            scenarioStressed.tirCostLastYearValue
          ),
          finalPerformanceValue: formatInt(
            Number(
              scenarioStressed.finalPerformanceArr[
                Number(this.$store.state.yearValue) - 1
              ].toFixed(2)
            )
          ),
          capitalValue: formatInt(this.$store.state.capitalValue)
        },
        {
          y: Number(
            scenarioUnfavorable.surrenderValueArr[
              Number(this.$store.state.yearValue) - 1
            ].toFixed(2)
          ),
          surrenderCapital: formatInt(
            Number(
              scenarioUnfavorable.surrenderValueArr[
                Number(this.$store.state.yearValue) - 1
              ].toFixed(2)
            )
          ),
          deathIncidentCapital: formatInt(
            Number(
              scenarioUnfavorable.deathTotalArr[
                Number(this.$store.state.yearValue) - 1
              ].toFixed(2)
            ) +
              Number(
                scenarioUnfavorable.ACMAExtraProtectionValuieArr[
                  Number(this.$store.state.yearValue) - 1
                ].toFixed(2)
              )
          ),
          deathTrafficAccidentCapital: formatInt(
            Number(
              scenarioUnfavorable.deathTotalArr[
                Number(this.$store.state.yearValue) - 1
              ].toFixed(2)
            ) +
              2 *
                Number(
                  scenarioUnfavorable.ACMAExtraProtectionValuieArr[
                    Number(this.$store.state.yearValue) - 1
                  ].toFixed(2)
                )
          ),
          deathValue: formatInt(
            Number(
              scenarioUnfavorable.deathTotalArr[
                Number(this.$store.state.yearValue) - 1
              ].toFixed(2)
            )
          ),
          tirCostLastYearValue: formatDecimal(
            scenarioUnfavorable.tirCostLastYearValue
          ),
          finalPerformanceValue: formatInt(
            Number(
              scenarioUnfavorable.finalPerformanceArr[
                Number(this.$store.state.yearValue) - 1
              ].toFixed(2)
            )
          ),
          capitalValue: formatInt(this.$store.state.capitalValue)
        },
        {
          y: Number(
            scenarioModerate.surrenderValueArr[
              Number(this.$store.state.yearValue) - 1
            ].toFixed(2)
          ),
          surrenderCapital: formatInt(
            Number(
              scenarioModerate.surrenderValueArr[
                Number(this.$store.state.yearValue) - 1
              ].toFixed(2)
            )
          ),
          deathIncidentCapital: formatInt(
            Number(
              scenarioModerate.deathTotalArr[
                Number(this.$store.state.yearValue) - 1
              ].toFixed(2)
            ) +
              Number(
                scenarioModerate.ACMAExtraProtectionValuieArr[
                  Number(this.$store.state.yearValue) - 1
                ].toFixed(2)
              )
          ),
          deathTrafficAccidentCapital: formatInt(
            Number(
              scenarioModerate.deathTotalArr[
                Number(this.$store.state.yearValue) - 1
              ].toFixed(2)
            ) +
              2 *
                Number(
                  scenarioModerate.ACMAExtraProtectionValuieArr[
                    Number(this.$store.state.yearValue) - 1
                  ].toFixed(2)
                )
          ),
          deathValue: formatInt(
            Number(
              scenarioModerate.deathTotalArr[
                Number(this.$store.state.yearValue) - 1
              ].toFixed(2)
            )
          ),
          tirCostLastYearValue: formatDecimal(
            scenarioModerate.tirCostLastYearValue
          ),
          finalPerformanceValue: formatInt(
            Number(
              scenarioModerate.finalPerformanceArr[
                Number(this.$store.state.yearValue) - 1
              ].toFixed(2)
            )
          ),
          capitalValue: formatInt(this.$store.state.capitalValue)
        },
        {
          y: Number(
            scenarioFavorable.surrenderValueArr[
              Number(this.$store.state.yearValue) - 1
            ].toFixed(2)
          ),
          surrenderCapital: formatInt(
            Number(
              scenarioFavorable.surrenderValueArr[
                Number(this.$store.state.yearValue) - 1
              ].toFixed(2)
            )
          ),
          deathIncidentCapital: formatInt(
            Number(
              scenarioFavorable.deathTotalArr[
                Number(this.$store.state.yearValue) - 1
              ].toFixed(2)
            ) +
              Number(
                scenarioFavorable.ACMAExtraProtectionValuieArr[
                  Number(this.$store.state.yearValue) - 1
                ].toFixed(2)
              )
          ),
          deathTrafficAccidentCapital: formatInt(
            Number(
              scenarioFavorable.deathTotalArr[
                Number(this.$store.state.yearValue) - 1
              ].toFixed(2)
            ) +
              2 *
                Number(
                  scenarioFavorable.ACMAExtraProtectionValuieArr[
                    Number(this.$store.state.yearValue) - 1
                  ].toFixed(2)
                )
          ),
          deathValue: formatInt(
            Number(
              scenarioFavorable.deathTotalArr[
                Number(this.$store.state.yearValue) - 1
              ].toFixed(2)
            )
          ),
          tirCostLastYearValue: formatDecimal(
            scenarioFavorable.tirCostLastYearValue
          ),
          finalPerformanceValue: formatInt(
            Number(
              scenarioFavorable.finalPerformanceArr[
                Number(this.$store.state.yearValue) - 1
              ].toFixed(2)
            )
          ),
          capitalValue: formatInt(this.$store.state.capitalValue)
        }
      ];

      this.chartOptions.series[1].data = [
        Number(this.$store.state.capitalValue),
        Number(this.$store.state.capitalValue),
        Number(this.$store.state.capitalValue),
        Number(this.$store.state.capitalValue)
      ];

      // console.log("this.scenarios.data", this.scenarios.data);
    },
    processData() {
      router.push("/summary");
    },
    showModal(type) {
      this.scenarioDetailType = type;
      this.modal = true;
    },
    back() {
      router.push("extra-protections");
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    }
  }
};
</script>
<style scoped>
.form-data:not(:root:root) {
  min-height: 300px;
}
@media screen and (min-color-index: 0) and(-webkit-min-device-pixel-ratio:0) {
  @media {
    .form-data {
      min-height: 390px;
    }
  }
}
</style>
